import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CaseTooth } from './models/CaseTooth';
import { MatDialog } from '@angular/material/dialog';
import { ScanSetupDlgComponent } from '../../modules/imaging/scan-setup-dlg/scan-setup-dlg.component';
import { DesktopAcquireCommandsModel } from './models/desktop-acquire-commands.model';
import { DocumentDataModel } from '../../models/document/document-data.model';
import { Globals } from '../../globals';
import { DialogService } from '../../services/dialog.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { FileManagerService } from '../../modules/file-manager/file-manager.service';
import { tryCatch } from 'rxjs/internal-compatibility';
import {Constants} from '../../constants';


@Injectable({
  providedIn: 'root'
})
export class TdoImagingService {
  public scanningService: lt.Scanning.IScanningSession;
  public isWindowsEnvironment: boolean = false;
  public isTwainServiceStarted: boolean = false;
  public isAcquiring: boolean = false;
  public folderMonitorNameList: FolderMonitorName[] = [];
  public folderMonitorNameListRunning: FolderMonitorName[] = [];
  public folderMonitorRunning: string = '';
  public folderMonitorName: FolderMonitorName;
  public isLTLicense: boolean;
  public isSBRunning: boolean = false;
  public wsNameWithMACAddress: string = '';
  isDisplayScanSetupDlg: boolean = false;
  isDisplayMessageBox: boolean = false;

  constructor(private http: HttpClient,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private localStorageService: LocalStorageService,
    private fileManagerService: FileManagerService,
    private globals: Globals) {
    const licenseUrl = 'assets/leadtools/Leadtools.lic.txt';
    const developerKey = 'pmuos0N+Ly8A1TjgwCef5g==';

    console.log('mtm lt.LTHelper.device ', lt.LTHelper.device);
    console.log('mtm lt.LTHelper.OS ', lt.LTHelper.OS);
    if (lt.LTHelper.device === lt.LTDevice.desktop) {
      console.log('mtm lt.LTHelper.device ', lt.LTHelper.device);
      console.log('mtm lt.LTHelper.OS ', lt.LTHelper.OS);
      if (lt.LTHelper.OS === lt.LTOS.windows || lt.LTHelper.OS === lt.LTOS.windows7 || lt.LTHelper.OS === lt.LTOS.windows8) {
        this.isWindowsEnvironment = true;
      }
    }
    if (this.isWindowsEnvironment) {
      this.scanningService = lt.Scanning.ScanningFactory.createSession('http://localhost/TDOxServiceBroker/');
    }
    lt.RasterSupport.setLicenseUri(licenseUrl, developerKey, (setLicenseResult) => {
      // Check the status of the license
      if (setLicenseResult.result) {
        this.isLTLicense = true;
        console.log('Leadtools client license set successfully');
      } else {
        this.isLTLicense = false;
        const msg = 'Leadtools License is missing, invalid or expired\nError:\n';
        console.log(msg);
        this.dialogService.openConfirmDialog(msg,
          false, false, 'Missing Leadtools License').subscribe((result) => {
          });

      }
    });

  }

  initServiceBroker(isDisplayScanSetupDlg: boolean = false, isDisplayMessageBox: boolean = false, isStartSB: boolean = true) {
    this.isDisplayScanSetupDlg = isDisplayScanSetupDlg;
    this.isDisplayMessageBox = isDisplayMessageBox;
    const serviceBrokerObservable = new Observable(observer => {
      setTimeout(() => {
        observer.next(this.isTwainServiceStarted);
      }, 5000);
    });
    if (this.isLTLicense) {
      if (isStartSB) {
        this.startServiceBroker();
      }
    }
    return serviceBrokerObservable;
  }
  startServiceBroker() {
    this.scanningService.start(null).done(() => {
      this.isTwainServiceStarted = true;
      this.isAcquiring = false;

      this.isFolderMonitorRunning(() => {
        const intervalSubscription = setInterval(_ => {
          if (this.folderMonitorRunning !== '') {
            clearInterval(intervalSubscription);
          }
        }, 100);
      });

    }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
      console.log(Date.now().toLocaleString() + ' fail ');
      // alert('Failed at ' + Date().toLocaleString());
      this.isTwainServiceStarted = false;
      this.isAcquiring = false;
      // call only if using Twain or Service broker or folder monitor to install service broker
      if (this.isDisplayScanSetupDlg === true) {
        this.scanSetupDlg();
      }
      if (this.isDisplayMessageBox === true) {
        this.dialogService.openConfirmDialog('Please go to \'Settings -> Practice Information -> Workstations\' to download the TDOx Service Broker.',
          false, false, 'Download Service Broker').subscribe((result) => {
            if (result === true) {
            }
          });

      }
    });
  }

  getTwainServiceStatus() {
    if (lt.LTHelper.device === lt.LTDevice.desktop) {
      if (lt.LTHelper.OS === lt.LTOS.windows || lt.LTHelper.OS === lt.LTOS.windows7 || lt.LTHelper.OS === lt.LTOS.windows8) {
        this.isWindowsEnvironment = true;
      }
    }

    if (this.isWindowsEnvironment) {
      this.scanningService = lt.Scanning.ScanningFactory.createSession('http://localhost/TDOxServiceBroker/');
      console.log('Attempting to start windows platform TDOxServiceBroker @ http://localhost/TDOxServiceBroker/');
    } else {
      // This is not implemented yet.
      this.scanningService = lt.Scanning.ScanningFactory.createSession('http://localhost:50000/ScanService/');
      console.log('Attempting to start unix platform scanservice @ http://localhost:50000/ScanService/');
    }

    this.scanningService.getStatus()
      .done((status) => {
        // Scanning service - getStatus succeed
        console.log('Scanning service - getStatus succeed');
      })
      .fail(() => {
        // Scanning service - getStatus failed
        this.startServiceBroker();
      });
  }

  getCaseTooth(patientCaseId: string, caseWorkItemId: string, toothNumberingId: string): Observable<CaseTooth[]> {
    return this.http.get<CaseTooth[]>(`api/draw/get-list-of-teeth/${patientCaseId}/${caseWorkItemId}/${toothNumberingId}`);

  }

  getSelectedCaseTooth(documentId: string): Observable<any> {
    return this.http.get<any>(`api/draw/get-selected-list-of-teeth/${documentId}`);

  }

  scanSetupDlg(msg: string = '') {
    const dialogRef = this.dialog.open(ScanSetupDlgComponent, {
      panelClass: 'dialog',
      disableClose: true,
      data: {
        _isWindowsEnvironment: this.isWindowsEnvironment,
        _message: msg
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // they pressed confirm
        console.log('pressed confirm ');
      } else {
        // they pressed cancel
        console.log('pressed cancel ');
      }
    }, err => {
      // something else happened
    });
  }
  getWSNameWithMacAddress(callback) {
    const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
    $.get(this.scanningService.runCommand('get-workstation-name-with-mac-address', desktopAcquireCommandArgs, null), (data) => {
      this.wsNameWithMACAddress = data;
    });
    setTimeout(() => {
      callback();
    }, 100);
  }
  isServiceBrokerRunning(callback) {
    if (this.isWindowsEnvironment) {
      const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
      console.log('service broker running check isSBRunning ', new Date(Date.now()), this.isSBRunning);
      $.get(this.scanningService.runCommand('isServiceBrokerRunning', desktopAcquireCommandArgs, null), (data) => {
        console.log('service broker running check result ', new Date(Date.now()), data);
        if (data === 'true') {
          this.isSBRunning = true;
        } else {
          this.isSBRunning = false;
        }
      });
      console.log('service broker running check end ', new Date(Date.now()));
      setTimeout(() => {
        callback();
      }, 100);
    }
  }
  isFolderMonitorRunning(callback) {
    const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
    desktopAcquireCommandArgs.PatientName = this.globals.currentPatientFullName;
    desktopAcquireCommandArgs.LocId = this.globals.LOCID;
    this.sendServiceBrokerCommand(desktopAcquireCommandArgs, 'is-folder-monitor-running');
    setTimeout(() => {
      callback();
    }, 100);
  }
  sendSBOpen3DVolume(dataDoc: DocumentDataModel, callback) {

    const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
    desktopAcquireCommandArgs.PatientId = this.globals.currentPatientId;
    desktopAcquireCommandArgs.VolumeName = dataDoc.PhysicalFileName;
    desktopAcquireCommandArgs.LocId = this.globals.LOCID;
    desktopAcquireCommandArgs.UserId = this.localStorageService.currentUserData.authdata.userid;
    desktopAcquireCommandArgs.PatientCaseId = dataDoc.PatientCaseId;
    desktopAcquireCommandArgs.enumDeviceSBId = dataDoc.DeviceID;
    desktopAcquireCommandArgs.PatientNO = this.globals.ThePatient.PatientNO;
    if (this.globals.ThePatient.BirthDate) {
      desktopAcquireCommandArgs.PatientDOB = this.globals.ThePatient.BirthDate;
    }
    desktopAcquireCommandArgs.Gender = this.globals.ThePatient.dataContact.enumGenderID;
    if (dataDoc.CaseWorkItemId === '' || dataDoc.CaseWorkItemId === 'null' ||
      dataDoc.CaseWorkItemId === null) {
      dataDoc.CaseWorkItemId = Constants.emptyGuid;
    }
    if (dataDoc.PatientCaseId !== null) {
      this.getCaseTooth(dataDoc.PatientCaseId, dataDoc.CaseWorkItemId,
        this.globals.currentToothNumberingId).subscribe((caseToothModelResponse) => {

        if (caseToothModelResponse) {
          if (caseToothModelResponse != null) {
            caseToothModelResponse.forEach(tooth => {
              tooth.NotationDescription = tooth.NotationDescription.replace('#', '');
              desktopAcquireCommandArgs.ToothList.push(tooth);
            });
          }
          console.log('mtm in sendSBOpen3DVolume caseToothModelResponse ', caseToothModelResponse);
          // desktopAcquireCommandArgs.ToothList = caseToothModelResponse;

          const tags: string[] = [];
          this.fileManagerService.getDocumentTags(dataDoc.DocumentID).subscribe((docTags) => {
            docTags.forEach(tag => {
              tags.push(tag.enumDocumentTagID);
            });
            desktopAcquireCommandArgs.Tags = tags;
          });
          $.get(this.scanningService.runCommand('open-3D-volume', desktopAcquireCommandArgs, null), (data) => {
          });
          if (Object.keys(caseToothModelResponse).length === 0) {
            console.log('No tooth');
          }
        }
      }, error => {
      });
    }
    else {
      desktopAcquireCommandArgs.PatientCaseId = Constants.emptyGuid;
      const tags: string[] = [];
      this.fileManagerService.getDocumentTags(dataDoc.DocumentID).subscribe((docTags) => {
        docTags.forEach(tag => {
          tags.push(tag.enumDocumentTagID);
        });
        desktopAcquireCommandArgs.Tags = tags;
        $.get(this.scanningService.runCommand('open-3D-volume', desktopAcquireCommandArgs, null), (data) => {
        });
      });
    }
    setTimeout(() => {
      callback();
    }, 100);
  }
  sendSBPrint(dataDocs: DocumentDataModel[], callback) {

    const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
    desktopAcquireCommandArgs.PatientId = this.globals.currentPatientId;
    desktopAcquireCommandArgs.LocId = this.globals.LOCID;
    desktopAcquireCommandArgs.UserId = this.localStorageService.currentUserData.authdata.userid;
    desktopAcquireCommandArgs.DocumentFilenames = dataDocs.map(p => p.DocumentFileName);
    $.get(this.scanningService.runCommand('print', desktopAcquireCommandArgs, null), (data) => {
    });
    setTimeout(() => {
      callback();
    }, 100);

  }
  sendServiceBrokerCommand(acquireCommandArgs: DesktopAcquireCommandsModel, commandType: string) {
    this.folderMonitorNameList = [];
    try {
      const emptyGuid = '00000000-0000-0000-0000-000000000000';
      const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
      desktopAcquireCommandArgs.PatientName = acquireCommandArgs.PatientName;
      desktopAcquireCommandArgs.PatientNO = acquireCommandArgs.PatientNO;
      desktopAcquireCommandArgs.PatientDOB = acquireCommandArgs.PatientDOB;
      desktopAcquireCommandArgs.Gender = acquireCommandArgs.Gender;
      desktopAcquireCommandArgs.LocId = acquireCommandArgs.LocId;
      desktopAcquireCommandArgs.UserId = acquireCommandArgs.UserId;
      desktopAcquireCommandArgs.PatientId = acquireCommandArgs.PatientId;
      desktopAcquireCommandArgs.enumDeviceSBId = acquireCommandArgs.enumDeviceSBId;
      desktopAcquireCommandArgs.enumDeviceCategoryId = acquireCommandArgs.enumDeviceCategoryId;
      desktopAcquireCommandArgs.FolderMonitorName = acquireCommandArgs.FolderMonitorName;
      if (acquireCommandArgs.PatientCaseId == null || acquireCommandArgs.PatientCaseId === 'undefined' ||
        acquireCommandArgs.PatientCaseId === 'null' || acquireCommandArgs.PatientCaseId === undefined) {
        desktopAcquireCommandArgs.PatientCaseId = emptyGuid;
      }
      else {
        desktopAcquireCommandArgs.PatientCaseId = acquireCommandArgs.PatientCaseId;
      }
      if (acquireCommandArgs.Tags != null) {
        acquireCommandArgs.Tags.forEach(tag => {
          desktopAcquireCommandArgs.Tags.push(tag);
        });
        if (acquireCommandArgs.ToothList != null) {
          acquireCommandArgs.ToothList.forEach(tooth => {
            tooth.NotationDescription = tooth.NotationDescription.replace('#', '');
            desktopAcquireCommandArgs.ToothList.push(tooth);
          });
        }
      }
      $.get(this.scanningService.runCommand(commandType, desktopAcquireCommandArgs, null), (data) => {
        console.log('sendServiceBrokerCommand data ', data);
        if (commandType === 'get_folder_monitor_names') {
          this.folderMonitorNameList = data;
        }
        if (commandType === 'is-folder-monitor-running') {
          if (data === 'null') {
            this.folderMonitorRunning = 'false';
          }
          else {
            try {
              this.folderMonitorNameListRunning = JSON.parse(data);
              if (this.folderMonitorNameListRunning.length > 0) {
                this.folderMonitorRunning = 'true';
              }
              else {
                this.folderMonitorRunning = 'false';
              }
            }
            catch (e) {
              this.folderMonitorRunning = 'false';
            }
          }
        }
        setTimeout(() => {
          this.scanningService.getStatus()
            .done((status: lt.Scanning.ScanningStatus) => {
            })
            .fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {

            });
        }, 1000);
      });
    }
    catch (e) {
      alert(e);
    }
  }

}

export class FolderMonitorName {
  MonitorName: string;
}
